import parsePhoneNumber from 'libphonenumber-js';

export const cellNumberTransform = (value: string) => {
  const phoneNumber = parsePhoneNumber(value);
  const isUsPhoneNumber = phoneNumber?.country === 'US';

  if (isUsPhoneNumber) {
    const countryCode = phoneNumber.countryCallingCode;
    const areaCode = phoneNumber.nationalNumber.slice(0, 3);
    const centralOfficeCode = phoneNumber.nationalNumber.slice(3, 6);
    const lineNumber = phoneNumber.nationalNumber.slice(6);
    return `+${countryCode} (${areaCode}) ${centralOfficeCode}-${lineNumber}`;
  } else {
    return phoneNumber?.formatInternational() ?? value;
  }
};
